import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getOrderState, OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import loadOrder from "@insite/client-framework/Store/Pages/OrderStatus/Handlers/LoadOrder";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Page from "@insite/mobius/Page";
import { HasToasterContext, withToaster } from "@insite/mobius/Toast/ToasterContext";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import displayOrderStatus from "@MasterBluePrint/Store/Pages/OrderStatus/Handlers/DisplayOrderStatus";
import themeColors, { themeFontSizes, themeFontWeights } from "@MasterBluePrint/Styles/variables";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";


const mapStateToProps = (state: ApplicationState) => {
    const location = getLocation(state);
    const parsedQuery = parseQueryString<{
        ordernumber?: string;
        stemail?: string;
        stpostalcode?: string;
        orderNumber?: string;
        stEmail?: string;
        stPostalCode?: string;
    }>(location.search);
    const orderState = getOrderState(state,parsedQuery.orderNumber);
    return {
        orderState,
        orderNumber: parsedQuery.orderNumber ?? parsedQuery.ordernumber,
        sTEmail: parsedQuery.stEmail ?? parsedQuery.stemail ?? "",
        sTPostalCode: parsedQuery.stPostalCode ?? parsedQuery.stpostalcode ?? "",
        order: state.pages.orderStatus.order,
        isLoading: state.pages.orderStatus.isLoading,
    };
};

const mapDispatchToProps = {
    loadOrder,
    displayOrderStatus
};

export interface OrderStatusPageStyles {
    mainOrderStatus?: InjectableCss;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
}
export const orderStatusPageStyles: OrderStatusPageStyles = {
    centeringWrapper: {
        css: css`
            height: 18.75rem;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
    mainOrderStatus : {
        css: css`
        .printInvoiceBtn {
            display:none;
        }
        @media print {
            .card_container__wrapper {
                padding: 0.625rem;
            }
        }
        
        > div {
            > div:first-child {
                > div > div > div {
                    h1[data-test-selector="PageTitle"] {
                        @media print {
                            margin-bottom: 1rem;
                            
                            &:after {
                                display: none;
                            }
                        }
                        @media print and (orientation: landscape){
                            margin-bottom: 0.5rem;
                        }
                    }
                }
            }
            > div:nth-child(2){
                border-radius: 2px;
                background-color: ${themeColors.colorBackground};
                box-shadow: 0 2px 4px 4px rgba(0,0,0,0.03);
                padding: 1.875rem;

                @media print and (orientation: landscape){
                    padding: 1rem;
                }

                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            padding: 1rem;
                        `,
                    ],
                    "max",
                )}


                > div {
                    > div:first-child {
                        p[class^="TypographyStyle"],
                        p[class*="TypographyStyle"] {
                            width: 21.625rem;
                            color: ${themeColors.colorCharcoalGrey};
                            font-family: 'Roboto', sans-serif;
                            font-size: ${themeFontSizes.size16};
                            letter-spacing: 0.0112rem;
                            line-height: 1.4375rem;
                            font-weight: ${themeFontWeights.fontWeightRegular};

                            @media screen and (max-width: 1279px) {
                                width: auto;
                            }
                        }
                    }
                }
            }
            > div:nth-child(3){
                padding: 35px 0 30px 0;
                    @media print and (orientation: portrait){
                        padding: 20px 0;
                    }
                    @media print and (orientation: landscape){
                        padding: 25px 0 20px;
                    }
                > div {
                    @media print and (orientation: landscape) {
                        display: flex;
                        flex-direction: column;
                    }
                    > div:first-child {
                        @media print {
                            width: 100%;
                            max-width: 100%;
                        }
                        
                        @media print and (orientation: landscape) {
                            page-break-after: always;
                        }
                        
                        > div {
                            > div:first-child {
                                @media print and (orientation: portrait){
                                    display: none;
                                }
                                @media print and (orientation: landscape){
                                    display: none;
                                }
                            }
                            > div:nth-child(2) {
                                > div {
                                    > div {
                                        > div {
                                            > div:first-child {
                                                border-bottom: 1px solid #C2D1D9;
                                                border-top: 1px solid #C2D1D9;
                                                padding-top: 15px;
                                                margin-bottom: 1.25rem;
                                                ${({ theme }: { theme: BaseTheme }) =>
                                                            breakpointMediaQueries(
                                                            theme,
                                                            [
                                                                null,
                                                                css`
                                                                    text-align: center;

                                                                    > div {
                                                                        > div[class^='GridItemStyle'], div[class*='GridItemStyle'] {
                                                                            @media print {
                                                                                padding-top: 0 !important;
                                                                            }
                                                                            &:first-child {
                                                                                padding-top: 1.25rem;
                                                                            }
                                                                            &:last-child {
                                                                                padding-bottom: 1.25rem;
                                                                            }
                                                                            > div {
                                                                                > div {
                                                                                    padding-bottom: 0;
                                                                                    @media print {
                                                                                        padding-bottom: 0.3125rem;
                                                                                    }

                                                                                    h3[class^='TypographyStyle'],
                                                                                    h3[class*='TypographyStyle'],
                                                                                    span[class^='TypographyStyle'],
                                                                                    span[class*='TypographyStyle']{
                                                                                        margin-bottom: 0;
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                `,
                                                            ],
                                                            "max",
                                                        )}
                                            }
                                            > div:nth-child(2){
                                                margin-bottom: 0.75rem;

                                                > div {
                                                    > div:first-child {
                                                        > div {
                                                            background: #FFFFFF;
                                                            padding: 0.9375rem 1.5625rem 1.5625rem;
                                                        }

                                                        ${({ theme }: { theme: BaseTheme }) =>
                                                        breakpointMediaQueries(
                                                            theme,
                                                            [
                                                                null,
                                                                null,
                                                                null,
                                                                css`
                                                                    margin-right: 0.9375rem;
                                                                    max-width: 43%; 
                                                                `,
                                                            ],
                                                            "min",
                                                        )}
                                                    }
                                                    > div:nth-child(2) {
                                                        padding: 0.9375rem 0.2rem 0.4688rem .5625rem;
                                                                                                                      
                                                        ${({ theme }: { theme: BaseTheme }) =>
                                                        breakpointMediaQueries(
                                                            theme,
                                                            [
                                                                null,
                                                                css`
                                                                    padding-top: 1.25rem;
                                                                    max-width: 50%;
                                                                `,
                                                            ],
                                                            "max",
                                                        )}

                                                    }
                                                    > div:last-child {
                                                        padding: 0.9375rem 0.8rem 0.4688rem 1.125rem;

                                                        ${({ theme }: { theme: BaseTheme }) =>
                                                        breakpointMediaQueries(
                                                            theme,
                                                            [
                                                                null,
                                                                css`
                                                                    padding-top: 1.25rem;
                                                                    max-width: 50%;
                                                                `,
                                                            ],
                                                            "max",
                                                        )}
                                                    }
                                                }
                                            }
                                            > div:last-child {
                                                padding: 0.625rem;
                                                border-radius: 2px;
                                                background-color: #F0F2F3;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    > div:last-child {
                        @media print {
                            width: 50%;
                            max-width: 50%;
                        }
                        > div {
                            background: #fff;
                            padding: 20px;
                            box-shadow: 0 2px 4px 4px rgba(0,0,0,0.03);
                            border-radius: 2px;
                            &:empty{
                                display: none;
                            }
                        }
                    }
                }               
            }
            @media screen and (max-width: 1199px) {
                padding-top: 1.5625rem;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        null,
                        css`
                            padding: 0 0.6rem;
                        `,
                    ],
                    "minMax",
                )}

        }
        `,
    }
}

type Props = PageProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasToasterContext;

class OrderStatusPage extends React.Component<Props> {
    UNSAFE_componentWillMount() {
        // The share entity (for orders) functionality can use this page
        // to render HTML for PDF generation, so we need to leave this SSR
        // ability so that functionality works.
        this.loadOrderIfNeeded();
    }

    componentDidUpdate(prevProps: Props) {
        if (
            this.props.orderNumber !== prevProps.orderNumber ||
            this.props.sTEmail !== prevProps.sTEmail ||
            this.props.sTPostalCode !== prevProps.sTPostalCode
        ) {
            this.loadOrderIfNeeded();
        }
    }

    loadOrderIfNeeded = () => {
        const { orderNumber, sTEmail, sTPostalCode, order, loadOrder, toaster, isLoading } = this.props;
        if (!orderNumber || (!sTEmail && !sTPostalCode)) {
            return;
        }

        if ((order && (order.webOrderNumber === orderNumber || order.erpOrderNumber === orderNumber)) || isLoading) {
            return;
        }

        this.setState({
            isLoading : true
        });

        loadOrder({
            orderNumber,
            sTEmail,
            sTPostalCode,
            onComplete: () =>{
                this.setState({
                    isLoading : false
                });
            },
            onError: (errorMessage: string) => {
                this.setState({
                    isLoading : false
                });
                toaster.addToast({ body: errorMessage, messageType: "danger" });
            },
        });
    };

    render() {
        const styles = orderStatusPageStyles;
        return (
            <Page data-test-selector="orderStatus" {...styles.mainOrderStatus}>
                {(this.props.orderState.isLoading) ? (
                    <StyledWrapper {...styles.centeringWrapper} className="test-spinner">
                        <LoadingSpinner {...styles.spinner} />
                    </StyledWrapper>
                ): (
                    <OrderStateContext.Provider value={this.props.orderState}>
                        <Zone contentId={this.props.id} zoneName="Content" />
                    </OrderStateContext.Provider>
                )}
                <Modals />
            </Page>
        );
    }
}

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withToaster(OrderStatusPage)),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "System",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "OrderStatusPage" instead of this constant.
 */
export const OrderStatusPageContext = "OrderStatusPage";
